<template>

    <div class="widM padLS padRS padTS padBX" style="border:3px solid #71020f;background-color:#fff;color:#2c2c2c">
      <dl>
          <dt class="marTL txtC"><b class="disIb" style="background-color:#71020f;width:40%;max-width:150px;padding:0.6em 0;color:#fff;border-radius:2em;">신청 기간</b></dt>
          <dd class="marTM fntH6 txtC bold">10월 8일(금) 오전 10시 ~ 10월 11일(월) 자정 <em class="light" style="color:#808285;">*한정수량</em></dd>
      </dl>
      <dl>
          <dt class="marTL txtC"><b class="disIb" style="background-color:#71020f;width:40%;max-width:150px;padding:0.6em 0;color:#fff;border-radius:2em;">참여 방법</b></dt>
          <dd class="widXS marTM fntH6 bold">
              <ol>
                  <li>STEP 1 : 페이지 하단을 통해 이벤트 신청</li>
                  <li>STEP 2 : 정상 접수 여부 바로 확인</li>
                  <li>STEP 3 : 신청자 앞으로 발송되는 카카오톡 알림톡 확인</li>
                  <li>STEP 4 : 공병과 함께 ABC 매장 방문하여 샘플 수령</li>
              </ol>
              <div class="marTS txtC" style="color:#808285;">
                  <img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/item01.jpg" alt="제품 이미지" class="icoL">
                  <p class="fntP bold">스킨 뉴트리션 퍼밍 울트라 리프팅 크림 미니 <br>(4만원 상당)</p>
              </div>
          </dd>
      </dl>
      <dl>
          <dt class="marTL txtC"><b class="disIb" style="background-color:#71020f;width:40%;max-width:150px;padding:0.6em 0;color:#fff;border-radius:2em;">수령 기간</b></dt>
          <dd class="marTM fntH6 txtC bold">10월 15일(금) ~ 10월 22일(금)</dd>
      </dl>
      <dl>
          <dt class="marTL txtC"><b class="disIb" style="background-color:#71020f;width:40%;max-width:150px;padding:0.6em 0;color:#fff;border-radius:2em;">공병 기준</b></dt>
          <dd class="widXS marTSM fntP bold">
              <p>수거 공병의 기준을 반드시 유의하시기 바랍니다.</p>
              <ul class="padTS">
                  <li class="marTS">
                      <b><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/02/0204_artnutri/bull_01.png" alt="" style="height:1em"> 수거 공병 리스트</b>
                      <div class="osResNoticeList padLM">
                          <ul>
                              <li>- 아티스트리 유스 익스텐드 라인 제품 공병 : 113800V, 113801V, 113802V, 113810V, 113806V, 113808V</li>
                              <li>- 아티스트리 유스 익스텐드 울트라 라인 제품 공병 : 117018V, 117016V</li>
                              <li>- 아티스트리 스킨 뉴트리션 밸런싱 라인 제품 공병 : 123792J, 123797J, 123794J</li>
                              <li>- 아티스트리 스킨 뉴트리션 하이드레이팅 라인 제품 공병 : 123793J, 123795J, 123796J, 123798J</li>
                              <li>- 아티스트리 스킨 뉴트리션 클렌징류 : 123791J</li>
                          </ul>
                      </div>
                  </li>
                  <li class="marTS">
                      <b><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/02/0204_artnutri/bull_01.png" alt="" style="height:1em"> 제외 대상</b>
                      <div class="osResNoticeList padLM">
                          <ul>
                              <li>- 상기에 명시된 기준 외 아티스트리 제품 공병</li>
                              <li>- 증정용 샘플 공병</li>
                          </ul>
                      </div>
                  </li>
                  <p class="marTS" style="padding-left:0.5em;text-indent:-0.5em;">*선물세트 구성품의 미니 샘플, 박스는 공병으로 인정되지 않습니다.</p>
              </ul>
          </dd>
      </dl>
      <dl>
          <dt class="marTL txtC"><b class="disIb" style="background-color:#71020f;width:40%;max-width:150px;padding:0.6em 0;color:#fff;border-radius:2em;">유의 사항</b></dt>
          <dd class="marTSM fntP widXS">
              <div class="osResNoticeList">
                  <ul>
                      <li>- 본 이벤트는 한정 수량으로 조기 종료될 수 있습니다.</li>
                      <li>- ABO ID당 총 1회 참여가 가능합니다.</li>
                      <li>- 대리 수령이 불가합니다.</li>
                      <li>- 이벤트 정상 접수 여부를 반드시 확인하시기 바랍니다.</li>
                      <li>- 신청한 ABC에서만 교환이 가능하며, 변경 처리는 어렵습니다.</li>
                      <li>- 기준에 부합하지 않은 공병으로는 샘플 교환 처리가 어렵기 때문에 공병 기준에 대해 숙지 부탁 드립니다.</li>
                      <li>- 본 이벤트에 참가하신 분들 중 이벤트에 선정되신 분들에게 공병 교환 관련 알림톡이 발송됩니다. (순차 발송)</li>
                      <li>- 본 알림톡을 지정하신 ABC에서 교환 시 공병과 함께 지참하여 주십시오.</li>
                      <li>- 알림톡은 주사업자 앞으로 등록된 전화 번호로 전송되기 때문에 이벤트 신청에 앞서 전화 번호 확인을 부탁 드립니다.</li>
                  </ul>
              </div>
          </dd>
      </dl>

      <hr class="widL marTL marBL" style="border-top:1px solid #e4e4e4">

      <!-- 매장 선택 -->
      <div class="amway-theme widXS">
        <p class="fntP"><strong>방문할 ABC 매장을 선택 해 주세요.(변경 불가)</strong></p>
        <div class="radio-wrapper marTSM">
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '01', '분당')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >분당</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '02', '강서')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >강서</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '80', '인천')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >인천</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '07', '대전')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >대전</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '48', '청주')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >청주</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '05', '부산')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >부산</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '08', '대구')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >대구</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '49', '창원')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >창원</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '46', '울산')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >울산</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '06', '광주')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >광주</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '41', '전주')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >전주</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '43', '강릉')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >강릉</span>
          </label>
          <label class="amw-radio-wrap radio-label marLM marRM" @click="$emit('changelocale', '04', '제주')">
            <input type="radio" name="local" class="amw-global-radio">
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text" >제주</span>
          </label>
        </div>
        <!-- //radio-wrapper -->
        <div class="marTS light">
            <input id="remember" type="checkbox"  @click="$emit('changeagree')">
            <label for="remember" class="normal inline-label checklabel">상기 이벤트 내용에 모두 동의합니다.</label>
        </div>

        <div class="marTM txtC">
          <a @click="clickApply" class="osResBtn01" style="background-color:#71020f;width:70%;max-width:250px;padding:0.7em 0;color:#fff;border-radius:2em;">이벤트 신청하기</a>
        </div>
      </div>
      <!-- //매장 선택 -->
    </div>
    <!-- //content -->

</template>

<script>

export default {
  name: 'WasteGlassApply',
  props: ['abcLocale', 'agrees'],
  methods: {
    clickApply: function () {
      if (!this.abcLocale) {
        alert('방문할 ABC 를 선택해주세요')
      } else if (!this.agrees) {
        // eslint-disable-next-line no-undef
        layerPopOver(this, '.pop_artnutri_210924_04')
        return false
      } else {
        this.$emit('clickapply')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/nutrilite/waste-glass-bottle2/component/apply.vue